import getStringAfterFirstDot from './get-string-after-first-dot';
const getKeysFromTemplate = template => {
  if (!template) return [];
  const matches = Array.from(template.matchAll(/{{\s?(#\w+ )?([\w\.]+)\s?}}/gi));
  if (!matches.length) return [];
  return matches.map(item => getStringAfterFirstDot(item[2])).filter((key, index, matchedItem) => matchedItem.indexOf(key) === index);
};
export default getKeysFromTemplate;
//# sourceMappingURL=get-keys-from-template.js.map